
export default {

  saveAccountSettings: '/api/accountSettings/saveAccountSettings',
  getAccountSettings: '/api/accountSettings/getAccountSettings',
  savePassword: '/api/accountSettings/savePassword',
  getImageData: '/api/accountSettings/getImageData'

}



// WEBPACK FOOTER //
// ./src/urls/accountSettingsUrls.js